import React from "react";
import { AuthContextProvider } from "./DocTransmittal.context";
import DocTransmittalMain from "./Main";

const DocumentTransmittalTab = () => {
  return (
    <AuthContextProvider>
      <DocTransmittalMain />
    </AuthContextProvider>
  );
};

export default DocumentTransmittalTab;
